import Vue from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'UA-130695229-1',
  router
})

new Vue({
  router,
  vuetify,
  render: h => h(App),
  data: {
    clientId: 'ca0hqr8dgoaandys262cwdnvh1thdb',
    userId: '105937611',
    token: localStorage.token,
    isLoggedIn: localStorage.token != null ? true : false,
  },
}).$mount('#app')